export const ROUTES = {
  LOGIN: '/login',
  LOGIN_DEV: '/login/desenvolvedor',
  ACCESS_DENIED: '/login/acesso-negado',

  PREDICTIONS: '/predicoes',
  DASHBOARD: '/dashboard',
  SENDINGS: '/envios',
  PROFILE: '/perfil',
  PROCESSING: '/processamento',
  USERS: '/usuarios',

  DEFAULT_AUTHENTICATED: '/predicoes',
} as const

export const buildRoute = {
  processingDetails: (id: string | number) => `/processamento/detalhes/${id}`,
  userEdit: (id: string | number) => `/usuarios/editar/${id}`,
} as const
